import FormSubmission from "./FormSubmission.interface"
import Input from "./Input.interface"
import Media from "./Media.interface"

export default interface Form {
    id: number
    tenant_id: number
    name?: string
    type: FormType
    fields: FormField[]
    styles: FormStyles
    submissions?: number
    send_message: string
    send_media?: Media
    response_message: string
    response_media?: Media
    global_enabled: boolean
    created_at?: Date | string
    updated?: Date | string
    deleted_at?: Date | string
}

export interface FormField extends Input {
    id?: string
    cols?: number
    disableDelete?: boolean
    disableInputChange?: boolean
    disableRequired?: boolean
    order?: number
    options?: string[] | number[]
    required?: boolean
}

export interface FormMessage {
    title?: string
    helpText?: string
    attribute: FormMessageAttribute
    text: string
    media?: Media
    hidden?: boolean
}

export enum FormMessageAttribute {
    response_message = 'response_message',
    send_message = 'send_message',
    subscribe_message = 'subscribe_message',
    unsubscribe_message = 'unsubscribe_message'
}

//  FORM.STYLES
export interface FormStyles {
    footer: FormStylesFooter
    form: FormStylesForm
    page: FormStylesPage
    success: FormStylesSuccess
}

//  FORM.STYLES.FOOTER
export interface FormStylesFooter {
    display: boolean
}

//  FORM.STYLES.FORM
export interface FormStylesForm {
    button: FormStylesFormButton
    privacyPolicy: string,
    termsOfService: string,
    image: FormStylesFormImage
    inputs: FormStylesFormInputs
    title: FormStylesFormTitle
}
//  FORM.STYLES.FORM.BUTTON
export interface FormStylesFormButton {
    value: string
    'text-color': string
    color: string
    'border-radius': number | string
}
//  FORM.STYLES.FORM.IMAGE
export interface FormStylesFormImage {
    src: string
}
//  FORM.STYLES.FORM.INPUTS
export interface FormStylesFormInputs {
    columns: number | string
    width: number | string
    'justify-content': string
    props: FormStylesFormInputsProps
}
//  FORM.STYLES.FORM.INPUTS.PROPS
export interface FormStylesFormInputsProps {
    'background-color': string
    color: string
    dark: boolean
    dense: boolean
    filled: boolean
    height: number | string
    rounded: boolean
    shaped: boolean
}
//  FORM.STYLES.FORM.TITLE
export interface FormStylesFormTitle {
    value: string
    size: number | string
    color: string
    'letter-spacing': number | string
}

//  FORM.STYLES.PAGE
export interface FormStylesPage {
    inner: FormStylesPageInner
    font: FormStylesPageFont
}
//  FORM.STYLES.PAGE.FONT
export interface FormStylesPageFont {
    'font-family': string
}
//  FORM.STYLES.PAGE.INNER
export interface FormStylesPageInner {
    'background-color': string
    'background-image': string
}

//  FORM.STYLES.SUCCESS
export interface FormStylesSuccess {
    title: FormStylesSuccessTitle
    message: FormStylesSuccessMessage
    image: FormStylesSuccessImage
}
//  FORM.STYLES.SUCCESS.IMAGE
export interface FormStylesSuccessImage {
    src: string
}
//  FORM.STYLES.SUCCESS.MESSAGE
export interface FormStylesSuccessMessage {
    color: string
    'letter-spacing': number | string
    size: number | string
    value: string
}
//  FORM.STYLES.SUCCESS.TITLE
export interface FormStylesSuccessTitle {
    color: string
    'letter-spacing': number | string
    size: number | string
    value: string
}

export enum FormType {
    contactform = 'contactform',
    dynamicform = 'dynamicform'
}